(() => {
  if (customElements.get('lw-metaobject-dialog')) return;
  let active = null;
  let lock = null;
  class MetaobjectDialog extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.gallery = this.querySelector('.lw-mo-dialog__images');
      this.querySelector('[data-lw-dialog-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.release());
      this.querySelector('[data-lw-gallery-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-lw-gallery-next]')?.addEventListener('click', () => this.move(1));
      this.gallery?.addEventListener('scroll', () => this.updateIndex(), { passive: true });
      this.gallery?.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.querySelector('[data-lw-email]')?.addEventListener('click', event => {
        const link = event.currentTarget;
        const url = new URL(link.dataset.productUrl, window.location.origin);
        const selected = this.trigger?.closest('product-info')?.querySelector('input[name="id"]')?.value;
        if (selected) url.searchParams.set('variant', selected);
        const subject = `Product enquiry - ${link.dataset.product} - ${link.dataset.entry}`;
        const body = `Hi Luxiwood Team,\n\nI would like to enquire about ${link.dataset.entry}.\nProduct: ${link.dataset.product}\nProduct URL: ${url.href}\n\nMy questions:\n`;
        link.href = `mailto:${link.dataset.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      });
    }
    open(trigger) {
      if (this.dialog.open) return;
      if (active) {
        const previous = active;
        previous.dialog.close();
        previous.release();
      }
      this.trigger = trigger;
      this.dialog.showModal();
      lock = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      active = this;
      trigger?.setAttribute('aria-expanded', 'true');
      if (this.gallery) this.gallery.scrollLeft = 0;
      this.updateIndex();
    }
    release() {
      if (active !== this) return;
      {
        document.documentElement.style.overflow = lock?.html || '';
        document.body.style.overflow = lock?.body || '';
        lock = null; active = null;
      }
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() { this.release(); }
    move(direction) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.gallery?.scrollBy({ left: direction * this.gallery.clientWidth, behavior: reduced ? 'instant' : 'smooth' });
    }
    updateIndex() {
      const count = this.querySelector('[data-lw-gallery-index]');
      if (count && this.gallery?.clientWidth) count.textContent = String(Math.round(this.gallery.scrollLeft / this.gallery.clientWidth) + 1);
    }
  }
  customElements.define('lw-metaobject-dialog', MetaobjectDialog);
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-lw-metaobject-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.lwMetaobjectOpen);
    const component = dialog?.closest('lw-metaobject-dialog');
    if (component) { event.preventDefault(); component.open(trigger); }
  });
  // Join only consecutive collapsed components, including independent Shopify sections.
  function updateAccordionGroups() {
    document.querySelectorAll('[data-lw-accordion], .product-block--tab.tab-border').forEach(element => { element.dataset.lwJoinedBelow = 'false'; });
    document.querySelectorAll('[data-lw-accordion], .product-block--tab.tab-border').forEach(element => {
      const sectionHost = element.closest('.lw-mo-section')?.closest('.shopify-section');
      const host = sectionHost || element;
      let previous = host.previousElementSibling;
      while (previous && (previous.matches('script, style, link, template') || getComputedStyle(previous).display === 'none')) previous = previous.previousElementSibling;
      const previousAccordion = previous?.matches('[data-lw-accordion], .product-block--tab.tab-border') ? previous : previous?.matches('.shopify-section') ? previous.querySelector('.lw-mo-section [data-lw-accordion]') : null;
      const previousHost = previousAccordion?.closest('.lw-mo-section')?.closest('.shopify-section') || previousAccordion;
      const previousMargin = previousHost ? parseFloat(getComputedStyle(previousHost).marginBottom) : 0;
      const nativeDefaultGap = previousAccordion && !previousAccordion.hasAttribute('data-lw-accordion') && previousMargin === 20;
      const touching = previousHost && (previousMargin === 0 || nativeDefaultGap) && parseFloat(getComputedStyle(host).marginTop) === 0;
      element.dataset.lwJoinedAbove = String(Boolean(touching && (element.dataset.lwAccordionStyle === 'border' || element.classList.contains('tab-border')) && (previousAccordion.dataset.lwAccordionStyle === 'border' || previousAccordion.classList.contains('tab-border'))));
      if (element.dataset.lwJoinedAbove === 'true') previousAccordion.dataset.lwJoinedBelow = 'true';
    });
  }
  let groupFrame = 0;
  function scheduleAccordionGroups() {
    if (groupFrame) return;
    groupFrame = requestAnimationFrame(() => { groupFrame = 0; updateAccordionGroups(); });
  }
  updateAccordionGroups();
  new MutationObserver(scheduleAccordionGroups).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleAccordionGroups);
  document.addEventListener('shopify:section:reorder', scheduleAccordionGroups);
  document.addEventListener('shopify:block:select', scheduleAccordionGroups);
})();
